<template>
    <div
        class="relative grid grid-cols-12 gap-6 image-text-component container col-span-full"
        ref="elementRef"
    >
        <iframe style="aspect-ratio: 16 / 9; width: 100% !important;" :src="`https://www.youtube.com/embed/${encodeURIComponent(content?.['youtube-id'] ?? '')}`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen class="md:!col-start-auto h-auto object-cover col-span-full md:col-span-7 order rounded-sm self-center [.image-text-component:nth-of-type(even)_&]:md:order-4"></iframe>
        <div aria-hidden="true" class="col-span-1 [.image-text-component:nth-of-type(even)_&]:md:order-2 [.image-text-component:nth-of-type(even)_&]:lg:order-1"></div>
        <div aria-hidden="true" class="col-span-1 hidden [.image-text-component:nth-of-type(even)_&]:lg:block [.image-text-component:nth-of-type(even)_&]:lg:order-3"></div>
        <div class="flex flex-col gap-8 justify-center col-span-full md:col-span-4 lg:col-span-3 [.image-text-component:nth-of-type(even)_&]:md:order-1 [.image-text-component:nth-of-type(even)_&]:lg:order-2">
            <div :lang="mainStore.active_locale === 'nl_NL' ? 'nl' : 'en'" class="view-h3 font-medium hyphens-auto">{{get_localized_value(props.content?.title)}}</div>
            <div class="text-body">
                <RenderedHTML :value="content?.['body']" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>

import RenderedHTML from "~/components/view/RenderedHTML.vue"

const props = defineProps({
    content: {
        type: Object
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    }
})
const mainStore = useMainStore()
const { get_value: get_localized_value } = useLocalizedValue()

const emit = defineEmits(['enter', 'leave'])

const { elementRef, isInViewport } = useInViewport({
    threshold: 0.5,
    onEnter: () => emit('enter'),
    onLeave: () => emit('leave'),
})

</script>

<!--<style scoped lang="scss">-->
<!--</style>-->
